import {
  getRescheduleHistoryInput,
  RescheduleHistoryModel,
  useGetRescheduleHistory,
} from 'api-hooks/sale/reschedule';
import { NavigationRoutes } from 'common/constants';
import { ModelTransformer } from 'common/helpers/common';
import stylesColors from 'common/styles/styles.colors';
import { string2money } from 'common/utils/string';
import Separator from 'components/common/separator';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import useDate from 'hooks/use-date';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props extends getRescheduleHistoryInput {
  setData?: (data: RescheduleHistoryModel[]) => void;
  hide?: boolean;
}

export default function RescheduleHistoryTable(props: Props) {
  const { t } = useTranslation();
  const { saleId, type, setData, hide } = props;
  const formatDate = useDate();
  const { data, isLoading } = useGetRescheduleHistory(
    {
      saleId,
      type,
    },
    {
      onSuccess: (data) => {
        setData?.(
          ModelTransformer(
            data.data,
            RescheduleHistoryModel,
          ) as RescheduleHistoryModel[],
        );
      },
    },
  );

  const rowLink = React.useCallback(
    ({ original }) => {
      let navigation: NavigationRoutes;
      switch (type) {
        case 'activity':
          navigation = NavigationRoutes.ActivitySalesView;
          break;
        case 'cruise':
          navigation = NavigationRoutes.CruiseSalesView;
          break;
        case 'flight':
          navigation = NavigationRoutes.TicketSalesView;
          break;
        case 'hotel':
          navigation = NavigationRoutes.HotelSalesView;
          break;
      }

      if (typeof navigation === 'undefined') return undefined;

      return {
        pathname: navigation,
        query: {
          id: original.id,
        },
      };
    },
    [type],
  );

  const columns = React.useMemo<IColumn<RescheduleHistoryModel>[]>(
    () => [
      {
        header: t('common:invoice_number'),
        accessorKey: 'number',
        minSize: 180,
      },
      {
        header: t('common:reschedule_on'),
        accessorKey: 'rescheduleOn',
        minSize: 150,
        cell: ({ getValue }) =>
          getValue() ? formatDate(getValue() as Date, 'dd MMM yyyy') : '-',
      },
      {
        header: t('common:price'),
        accessorKey: 'price',
        minSize: 150,
        cell: ({ getValue }) => `Rp ${string2money(getValue() as string)}`,
        isNumber: true,
      },
    ],
    [formatDate, t],
  );

  if (
    isLoading ||
    (data &&
      (data.data === undefined || (data.data || []).length === 1) &&
      hide)
  ) {
    return <></>;
  }

  return (
    <>
      <TableComponent
        columns={columns}
        isLoading={isLoading}
        data={data?.data || []}
        headerColor={stylesColors.bg1}
        rowLink={rowLink}
        showBorder
      />
      <Separator gap={16} />
    </>
  );
}
